/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Translation_NoticeInputs */

const en_legal_translation_notice = /** @type {((inputs: Legal_Translation_NoticeInputs) => LocalizedString) & { parts: (inputs: Legal_Translation_NoticeInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Legal_Translation_NoticeInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`This is a translation. If it differs from the English version, the English version applies.`)
		}),
		{
			parts: /** @type {(inputs: Legal_Translation_NoticeInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "This is a translation. If it differs from the " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "English version" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ", the English version applies." }])
			})
		}
	)
);

const zh_legal_translation_notice = /** @type {((inputs: Legal_Translation_NoticeInputs) => LocalizedString) & { parts: (inputs: Legal_Translation_NoticeInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Legal_Translation_NoticeInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`本文件为译文。如与英文版本有任何不一致，以英文版本为准。`)
		}),
		{
			parts: /** @type {(inputs: Legal_Translation_NoticeInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "本文件为译文。如与" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "英文版本" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "有任何不一致，以英文版本为准。" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "This is a translation. If it differs from the English version, the English version applies." |
*
* @param {Legal_Translation_NoticeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const legal_translation_notice = /** @type {((inputs?: Legal_Translation_NoticeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & { parts: (inputs?: Legal_Translation_NoticeInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Legal_Translation_NoticeInputs, { locale?: "en" | "zh" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Legal_Translation_NoticeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh") return zh_legal_translation_notice(inputs)
			return en_legal_translation_notice(inputs)
		}),
		{
			parts: /** @type {(inputs?: Legal_Translation_NoticeInputs, options?: { locale?: "en" | "zh" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh") return /** @type {{ parts?: (inputs: Legal_Translation_NoticeInputs) => import('../runtime.js').MessagePart[] }} */ (zh_legal_translation_notice).parts?.(inputs) ?? [{ type: "text", value: zh_legal_translation_notice(inputs) }]
				return /** @type {{ parts?: (inputs: Legal_Translation_NoticeInputs) => import('../runtime.js').MessagePart[] }} */ (en_legal_translation_notice).parts?.(inputs) ?? [{ type: "text", value: en_legal_translation_notice(inputs) }]
			})
		}
	)
);